export const find = <T extends {id: string}>(
  id: string,
  list: T[],
): T | undefined => {
  return list.find(item => item.id === id);
};
